import { Radio, Tooltip } from 'antd'
import styled from 'styled-components'
import { colours } from '@qflow/theme'

const WASTE_FIELD_TYPES = {
  FACILITY_PERMIT: 'facilityPermitId',
  CONTAINER_TYPE: 'containerType'
} as const

const DELIVERY_FIELD_TYPES = {
  DISPATCH_ADDRESS: 'dispatchAddress'
} as const

export const FIELD_TYPES = {
  ...WASTE_FIELD_TYPES,
  ...DELIVERY_FIELD_TYPES
} as const

export type FieldType = (typeof FIELD_TYPES)[keyof typeof FIELD_TYPES]

type UpdateFieldSelectorProps = {
  selectedFieldType: FieldType
  handleFieldTypeChange: (e: any) => void
  isImperial: boolean
  moduleName: string
}

export function UpdateFieldSelector({
  selectedFieldType,
  handleFieldTypeChange,
  isImperial,
  moduleName
}: UpdateFieldSelectorProps) {
  const isWaste = moduleName === 'waste'
  const isDelivery = moduleName === 'delivery'

  // While we only have one field type for delivery, we will instead return just the heading,
  // but leaving the code in below ready for when a second option is created
  if (isDelivery) {
    return <h3>Update Records</h3>
  }

  return (
    <>
      <h3>Update Records</h3>
      <FieldInput style={{ alignItems: 'baseline' }}>
        <span>Update field</span>
        <StyledRadioGroup
          onChange={handleFieldTypeChange}
          value={selectedFieldType}
          optionType="button"
          buttonStyle="solid"
        >
          {isWaste && (
            <>
              <Radio value={FIELD_TYPES.FACILITY_PERMIT}>Facility Permit</Radio>
              <Tooltip
                title={isImperial ? 'Only available in the UK' : ''}
                placement="top"
              >
                <Radio value={FIELD_TYPES.CONTAINER_TYPE} disabled={isImperial}>
                  Container Type
                </Radio>
              </Tooltip>
            </>
          )}
          {isDelivery && (
            <Radio value={FIELD_TYPES.DISPATCH_ADDRESS}>Dispatch Address</Radio>
          )}
        </StyledRadioGroup>
      </FieldInput>
    </>
  )
}

export const FieldInput = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  > span {
    min-width: 7.25rem;
  }
`

const StyledRadioGroup = styled(Radio.Group)`
  // Add any custom styles for the Radio.Group here
  .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-disabled):hover,
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled),
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    ):hover {
    background-color: ${colours.CORE_NAVY};
    border-color: ${colours.CORE_NAVY};
    color: ${colours.WHITE};
  }
`
